import { createContext, useContext } from 'react';

const TournamentContext = createContext(null);

/**
 * Hook to access tournament state from any child component
 * @returns {Object} Tournament state
 */
export const useTournamentState = () => {
  const context = useContext(TournamentContext);
  if (!context) {
    throw new Error('useTournamentState must be used within TournamentProvider');
  }
  return context;
};

/**
 * Provider component to wrap the tournament app
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components
 * @param {Object} props.state - Tournament state from reducer
 */
export const TournamentProvider = ({ children, state }) => {
  return (
    <TournamentContext.Provider value={state}>
      {children}
    </TournamentContext.Provider>
  );
};
